import { Component, OnInit, Input, SimpleChanges, Output ,EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
@Component({
  selector: 'app-reply-comment-dialog',
  templateUrl: './reply-comment-dialog.component.html',
  styleUrls: ['./reply-comment-dialog.component.css']
})
export class ReplyCommentDialogComponent implements OnInit {

  @ViewChild('textArea') textArea:ElementRef;

  @Input() show: boolean;
  @Output() onDismissCallback:EventEmitter<boolean> = new EventEmitter();
  @Output() onSubmitCallBack:EventEmitter<string> = new EventEmitter();
  display = 'none';

  constructor(
    private courseService:CourseService
  ) { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.show){
      this.display = "block";
    }else{
      this.display = "none";
    }
  }
  
  onClose(){
    this.onDismissCallback.emit()
  }

  onSubmit(){
    const text = this.textArea.nativeElement.value
    this.textArea.nativeElement.value = ''
    this.onSubmitCallBack.emit(text)
  }

}
